// extracted by mini-css-extract-plugin
export default {"looksButtonWrapper":"vDJuQ"};